import React from "react";
import Modal from "react-bootstrap/Modal";
import TextInputOnRow from "components/GenericComponent/TextInputOnRow";
import { formatNumber } from "utils/currencyFormat";
import { getDate } from "utils/formatDate";
import DateTimePicker from "components/GenericComponent/DateTimePicker";
import { currentDate } from "utils/formatDate";
import { convertDate } from "utils/formatDate";
import { formatDayMonth } from "utils/formatDate";
import NoPhaiThuApi from "../../../service/noPhaiThuApi";
import { pushNotification } from "utils/notifications";
import { useSelector, useDispatch } from "react-redux";
import handleEscapeKey from "utils/handleEscapeKey";
class GiaHanNoPhaiThu extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isModalOpen: props.showGiaHanNoPhaiThu || false, // Trạng thái popup
      dataPost: {
        TimeMustPay: currentDate(),
        Note: "",
      },
      dataNoPhaiThuSearch: {
        choVayId: 0,
        pageIndex: 1,
        pageSize: 5,
      },
      editItem: null,
    };
    this.toggleModal = this.props.onHide.bind(this);
    // Tạo instance của useEscapeKey và gán vào this.escListener
    this.escListener = handleEscapeKey(this.props.onHide);
  }
  componentDidMount() {
     // Thêm listener chỉ khi modal mở
 if (this.state.isModalOpen) this.escListener.addListener();
    let { data, getLichSuNoPhaiThu } = this.props;
    let { dataNoPhaiThuSearch } = this.state;
    dataNoPhaiThuSearch.choVayId = data.ChoVayId;
    this.setState({
      choVay: data,
      dataNoPhaiThuSearch,
    });
    getLichSuNoPhaiThu(dataNoPhaiThuSearch);
  }
  onChangeDate = () => (evt) => {
    let { dataPost } = this.state;
    dataPost.TimeMustPay = formatDayMonth(evt);
    this.setState({ dataPost });
  };
  onKeyDownDate = (field) => (evt, evt1) => {
    let { dataPost } = this.state;
    if (evt.keyCode === 8) dataPost.TimeMustPay = "";
    this.setState({ dataPost });
  };
  onChangeNote = () => (evt) => {
    let { dataPost } = this.state;
    dataPost.Note = evt.target.value;
    this.setState({ dataPost });
  };

  componentWillUnmount() {
    // Gỡ listener khi component unmount
    this.escListener.removeListener();
  }

  toggleModal() {
    // Cập nhật trạng thái popup và thêm/xóa listener khi cần
    this.setState(
      (prevState) => ({ isModalOpen: !prevState.isModalOpen }),
      () => {
        if (this.state.isModalOpen) {
          this.escListener.addListener();
        } else {
          this.escListener.removeListener();
        }
      }
    );
  }

  setEditItem = (data) => () => {
    console.log(data, "hahahahah");
    this.setState({ editItem: { ...data } });
  };

  onChangeNoteEdit = () => (evt) => {
    let { editItem } = this.state;
    editItem.Note = evt.target.value;

    console.log(this.state.editItem, "editItemeditItemeditItem");
    this.setState({ editItem });
  };

  onChangeDateEdit = () => (evt) => {
    let { editItem } = this.state;

    console.log(this.state.editItem, "1editItemeditItemeditItem");
    editItem.TimeMustPay = formatDayMonth(evt);
    this.setState({ editItem });
  };

  deleteItemEdit = (data) => () => {
    let { getLichSuNoPhaiThu } = this.props;
    let { dataNoPhaiThuSearch } = this.state;
    dataNoPhaiThuSearch.choVayId = data.ChoVayID;
    NoPhaiThuApi.xoaGiaHanNo(data.ChoVayID, data.NoGiaHanID).then(
      (response) => {
        console.log(response, "responseresponse");
        if (response.status === 200) {
          if (response.data.Error === 0) {
            pushNotification(
              "Xoá gia hạn nợ thành công",
              "success",
              "TOP_CENTER",
              1000
            );
            getLichSuNoPhaiThu(dataNoPhaiThuSearch);
          } else {
            pushNotification(
              response.data.Message,
              "warning",
              "TOP_CENTER",
              1000
            );
          }
        } else {
          pushNotification(
            response.data.Message,
            "warning",
            "TOP_CENTER",
            1000
          );
        }
      }
    );
  };
  saveItemEdit = (data) => () => {
    let { getLichSuNoPhaiThu } = this.props;
    let { dataNoPhaiThuSearch, editItem } = this.state;
    dataNoPhaiThuSearch.choVayId = data.ChoVayID;
    const param2 = editItem;
    var params = param2;
    NoPhaiThuApi.editGiaHanNo(params).then((response) => {
      console.log(response, "responseresponse");
      if (response.status === 200) {
        if (response.data.Error === 0) {
          pushNotification(
            "Cập nhật gia hạn nợ thành công",
            "success",
            "TOP_CENTER",
            1000
          );
          editItem = null;
          this.setState({ editItem });
          getLichSuNoPhaiThu(dataNoPhaiThuSearch);
        } else {
          pushNotification(
            response.data.Message,
            "warning",
            "TOP_CENTER",
            1000
          );
        }
      } else {
        pushNotification(response.data.Message, "warning", "TOP_CENTER", 1000);
      }
    });
  };

  onHide = () => {
    this.setState({ isModalOpen: false });
    this.props.onHide();
  };

  renderTableRows() {
    let { chitiethopdong } = this.props;
    let { objLichSuNoPhaiThu } = chitiethopdong;
    let ListLSNoPhaiThu = objLichSuNoPhaiThu.List;
    return ListLSNoPhaiThu.map((item, index) => {
      let { CreatedTime, Value, Time, TimeMustPay, Note } = item;
      return (
        <div className="custom-table-row" key={"item" + index}>
          <div className="custom-table-cell username-cell flex-basis-6 disk-mobile">
            <span className="mobile-column-name">STT</span>
            <div className="center-wrapper">
              <p className="text-center">{index + 1}</p>
            </div>
          </div>

          <div className="row-show-three">
            <div className="row-mobile">
              <div className="custom-table-cell flex-basis-10  flex-disk">
                <span className="mobile-column-name disk-mobile">
                  Ngày gia hạn
                </span>
                <div className="center-wrapper">
                  <p className="icon-dropdown-mobile text-center">
                    <i className="mdi mdi-arrow-down-drop-circle collapsible"></i>
                    {getDate(CreatedTime)}
                  </p>
                </div>
              </div>

              <div className="custom-table-cell flex-basis-15 flex-disk ">
                <span className="mobile-column-name disk-mobile">
                  Số tiền phải thanh toán
                </span>
                <div className="center-wrapper">
                  <p className="text-right1 color-do-bold">{formatNumber(Value)}</p>
                </div>
              </div>
            </div>

            <div className="form-row-detail content12">
              <div className="custom-table-cell flex-basis-10">
                <span className="mobile-column-name ">Gia hạn cho Kỳ</span>
                <div className="center-wrapper">
                  <p className="text-center">{getDate(Time)}</p>
                </div>
              </div>

              <div className="custom-table-cell flex-basis-14">
                <span className="mobile-column-name">Ngày phải thanh toán</span>
                <div className="center-wrapper">
                  {(!this.state.editItem ||
                    this.state.editItem.NoGiaHanID !== item.NoGiaHanID) && (
                    <p className="text-center">{getDate(TimeMustPay)}</p>
                  )}
                  {this.state.editItem &&
                    this.state.editItem.NoGiaHanID === item.NoGiaHanID && (
                      <DateTimePicker
                        onChange={this.onChangeDateEdit()}
                        placeholder="Ngày phải trả"
                        value={convertDate(this.state.editItem.TimeMustPay)}
                      ></DateTimePicker>
                    )}
                </div>
              </div>

              <div className="custom-table-cell flex-basis-25">
                <span className="mobile-column-name">Lý do gia hạn</span>
                <div className="center-wrapper">
                  {(!this.state.editItem ||
                    this.state.editItem.NoGiaHanID !== item.NoGiaHanID) && (
                    <p className="text-left-right">{Note}</p>
                  )}
                  {this.state.editItem &&
                    this.state.editItem.NoGiaHanID === item.NoGiaHanID && (
                      <textarea
                        rows="1"
                        className="form-control input-sm text-era"
                        onChange={this.onChangeNoteEdit()}
                        value={this.state.editItem.Note}
                      ></textarea>
                    )}
                </div>
              </div>
              <div className="custom-table-cell flex-basis-10">
                <span className="mobile-column-name">Thao tác</span>
                <div className="center-wrapper">
                  <div class="iconTableMorman">
                    {(!this.state.editItem ||
                      this.state.editItem.NoGiaHanID !== item.NoGiaHanID) &&
                      item.isEditDelete === true && (
                        <a href={() => false} onClick={this.setEditItem(item)}>
                          <img src="/app-assets/images/icon-edit-v2.png"/>
                        </a>
                      )}

                    {this.state.editItem &&
                      this.state.editItem.NoGiaHanID === item.NoGiaHanID && (
                        <a href={() => false} onClick={this.saveItemEdit(item)}>
                            <img src="/app-assets/images/icon-save-v2.png"/>
                        </a>
                      )}

                    {(!this.state.editItem ||
                      this.state.editItem.NoGiaHanID !== item.NoGiaHanID) &&
                      item.isEditDelete === true && (
                        <a
                          href={() => false}
                          onClick={this.deleteItemEdit(item)}
                        >
                           <img src="/app-assets/images/icon-xoa-v2.png"/>
                        </a>
                      )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    });
  }
  postData = () => () => {
    let { Note, TimeMustPay } = this.state.dataPost;
    let { data, postGiaHanNoPhaiThu } = this.props;
    let { ChoVayId, maxtime, Value } = data;

    let dataSubmit = {
      ChoVayID: ChoVayId,
      Time: maxtime,
      Note: Note,
      Value: Value,
      TimeMustPay: TimeMustPay,
    };
    postGiaHanNoPhaiThu(dataSubmit);
  };
  render() {
    let { onHide, chitiethopdong, data, giahannophaithu } = this.props;
    let { objLichSuNoPhaiThu } = chitiethopdong;
    let TotalRowNoPhaiThu = objLichSuNoPhaiThu.TotalRows;
    let { TotalValue } = objLichSuNoPhaiThu;
    let { CustomerName, maxtime, Value, SoTienVayThuc, NgayVay } = data;
    let { dataPost } = this.state;
    let { TimeMustPay, Note } = dataPost;
    let { showGiaHanNoPhaiThu } = giahannophaithu;
    return (
      <Modal
        show={showGiaHanNoPhaiThu}
        onHide={this.onHide}
        size="modal-xl modal-xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="modal-new modal fade text-left"
      >
        <Modal.Header>
          <h4 className="modal-title  color7-bold" id="myModalLabel16">
            <span className="btn-icon-right icon-pop">
            <img  src="/app-assets/images/icon-gia-han-v2.png"/>
            </span>
            Gia hạn ngày thanh toán trong 1 kỳ
          </h4>
          <button type="button" className="close-popup-new" onClick={onHide}>
          <img  src="/app-assets/images/icon-dong-popup-v2.png"/>
          </button>
        </Modal.Header>
        <Modal.Body className="">
          <form className="form tat-toan form-horizontal">
            <div className="form-body">
              <div className="card collapse-icon accordion-icon-rotate">
                <div
                  id="headingCollapse66"
                  // className="card-header border-info"
                  href="#collapse66"
                  aria-expanded="true"
                  aria-controls="collapse66"
                  style={{width:"100%"}}
                >
                  <a
                    // className="card-title lead info collapsed"
                    href={() => false}
                  >
                    <h4 className="color-xanh-bold">
                      Gia hạn nợ phải thu &nbsp;<span className="ky-gia-han">&nbsp;Kỳ gia hạn: {getDate(maxtime)}&nbsp;</span>
                    </h4>
                  </a>
                </div>
                <div
                  id="collapse66"
                  aria-labelledby="headingCollapse66"
                  className="card-collapse collapse show"
                  aria-expanded="true"
                >
                  <div className="card-content mt-1">
                    <div className="card-body">
                      <div className="form-body row">
                        <div className="col-sm-12">
                          <div className="row">
                            <div className="col-sm-3">
                              <TextInputOnRow
                                labelClass="label-control color7-bold"
                                inputClass="form-control input-sm"
                                wrapperClass="form-group"
                                labelText=" Họ Tên"
                                disabled="disabled"
                                value={CustomerName}
                              ></TextInputOnRow>
                            </div>

                            <div className="col-sm-3">
                              <TextInputOnRow
                                labelClass="label-control color7-bold"
                                inputClass="form-control input-sm"
                                wrapperClass="form-group"
                                labelText="Ngày vay"
                                disabled="disabled"
                                value={getDate(NgayVay)}
                              ></TextInputOnRow>
                            </div>

                            <div className="col-sm-3">
                              <TextInputOnRow
                                labelClass="label-control color7-bold"
                                inputClass="form-control input-sm"
                                wrapperClass="form-group"
                                labelText="Số tiền vay"
                                disabled="disabled"
                                value={formatNumber(SoTienVayThuc)}
                              ></TextInputOnRow>
                            </div>

                            <div className="col-sm-3">
                              <TextInputOnRow
                                labelClass="label-control color7-bold"
                                inputClass="form-control input-sm"
                                wrapperClass="form-group"
                                labelText="Phải thu"
                                disabled="disabled"
                                value={formatNumber(Value)}
                              ></TextInputOnRow>
                            </div>
                            <br/>
                            <div className="col-sm-3">
                              <div className="form-group">
                                <label
                                  className="label-control  color7-bold"
                                  for="projectinput2"
                                >
                                  Gia hạn nợ đến ngày
                                </label>
                                <DateTimePicker
                                  onChange={this.onChangeDate()}
                                  onKeyDown={this.onKeyDownDate()}
                                  placeholder="Ngày phải trả"
                                  value={convertDate(TimeMustPay)}
                                ></DateTimePicker>
                              </div>
                            </div>

                            <div className="col-sm-9">
                              <div className="form-group">
                                <label
                                  className="label-control color7-bold "
                                  for="projectinput2"
                                >
                                  Lý do
                                </label>
                                <textarea
                                  rows="10"
                                  className="form-control input-sm text-era"
                                  onChange={this.onChangeNote()}
                                  value={Note}
                                  placeholder="Nhập lý do"
                                  style={{marginTop:"2px"}}
                                ></textarea>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <br/>
                <div
                  id="headingCollapse64"
                  className="card-header mt-1"
                  data-toggle="collapse"
                  href="#collapse64"
                  aria-expanded="true"
                  aria-controls="collapse54"
                >
                  <a
                    className="card-title lead info collapsed"
                    role="tabpanel"
                    href={() => false}
                  >
                    <h4 className="color-xanh-bold">Lịch sử gia hạn</h4>
                  </a>
                </div>
                <div
                  id="collapse64"
                  aria-labelledby="headingCollapse64"
                  className="card-collapse collapse show"
                  aria-expanded="true"
                  href={() => false}
                >
                  <div className="card-content">
                    <div className="card-body">
                      <div className="Left808x200 Table-main-new table-mobile-new1">
                        <div
                          className="table-responsive table-responsive-new table-new1  table-rounded"
                          style={{ overflow: "inherit !important" }}
                        >
                          <div className="custom-table-wrapper">
                            <div className="table-headers">
                              <div className="custom-table-header flex-basis-6">
                                <p className="text-center">
                                  <span className="color-do">
                                    [{TotalRowNoPhaiThu}]
                                  </span>
                                </p>
                                <br />{" "}
                              </div>
                              <div className="custom-table-header flex-basis-10 ">
                                <p className="text-center">Ngày gia hạn</p> <br />{" "}
                              </div>
                              <div className="custom-table-header flex-basis-15 ">
                                <p className="text-right">
                                  Số tiền phải thanh toán
                                  <br /> 
                                  <span className="color-do">
                                   {" "} {formatNumber(TotalValue)}
                                  </span>
                                </p>
                              </div>

                              <div className="custom-table-header flex-basis-10">
                                <p className="text-center">Gia hạn cho Kỳ</p>  <br />{" "}
                              </div>
                              <div className="custom-table-header flex-basis-14 ">
                                <p className="text-center">
                                  Ngày phải thanh toán
                                </p>  <br />{" "}
                              </div>
                              <div className="custom-table-header flex-basis-25 ">
                                <p className="text-left">Lý do gia hạn</p><br />{" "}
                              </div>
                              <div className="custom-table-header flex-basis-10 ">
                                <p className="text-left">Thao tác</p><br />{" "}
                              </div>
                            </div>

                            <div className="custom-table-body">
                              <div className="custom-table-row">
                                <div className="custom-table-cell username-cell-mobile flex-basis-15 flex-disk disk-desktop show-mobile">
                                  <span className="mobile-column-name">
                                    Ngày gia hạn
                                  </span>
                                  <div className="center-wrapper  ">
                                    <p className="text-right1">
                                      Số tiền phải thanh toán
                                    </p>
                                  </div>
                                </div>
                              </div>
                              {this.renderTableRows()}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer className="button-popup-new-size">
          <div className="from-button-modal">
            <div className="row">
              <div className="col-md-9">

              </div>
              <div className="col-md-3 text-right">
              <button
            type="button"
            className="btn btn-new-main btn-closenew"
            onClick={onHide}
          > 
            <span>
              <i className="mdi mdi-close"></i>
            </span>
            &nbsp;  Đóng
          </button>
          <button
           style={{marginLeft:"10px"}}
            type="button"
            className="btn btn-new-main button-popup-submit"
            onClick={this.postData()}
          >
            <span>
            <img  src="/app-assets/images/icon-true-v2.png"/>
            </span>
            &nbsp;   Xác nhận
          </button>
{/* 
                <a
                  href={() => false}
                  onClick={this.postData()}
                  className="btn btn-new-main btn-checknew"
                >
                  <span className="btn-icon-left">
                    <i className="mdi mdi-check"></i>
                  </span>
                  Xác nhận
                </a>
                <a
                  href={() => false}
                  className="btn btn-new-main btn-closenew"
                  onClick={onHide}
                >
                  <span className="btn-icon-left">
                    <i className="mdi mdi-close"></i>
                  </span>
                  Đóng
                </a> */}
              </div>
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    );
  }
}
export default GiaHanNoPhaiThu;
